import React, { useEffect } from 'react';

function OtherVenturesPageNew() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const ventures = [
    {
      name: "Radiant DRUV Pvt. Ltd",
      logo: "/assets/ventures/radiant-druv.svg",
      address: "Village – Bahwasipur, Tola – Bahwasipur, Panch - Shuriya, Mahiyama, Block - Sonhaula, District - Bhagalpur Bihar – 813205",
      email: "radiantdruv@gmail.com",
      description: "Leading provider of innovative solutions and services"
    },
    {
      name: "Trident Civil Solutions",
      logo: "/assets/ventures/trident-civil.svg",
      address: "Office No. 7, 1st Floor, Building No. 4, Awadh Homes, IC Colony Link Road, Borivali (West), Mumbai-400103, Maharashtra",
      email: "tridentcivlsolutions@gmail.com",
      description: "Specialized civil engineering and construction services"
    },
    {
      name: "Rama Agrotech",
      logo: "/assets/ventures/rama-agrotech.svg",
      address: "Village Vishwaspur, Post Office Mahiyama, Via Ghogha District Bhagalpur, Bihar, Pin- 813205",
      email: "agrotech.rama@gmail.com",
      description: "Agricultural technology and farming solutions"
    }
  ];

  return (
    <div id="other-ventures-page-view" className="view-section min-h-screen py-32 px-10 md:px-20 bg-black transition-all duration-500">
      <div className="max-w-7xl mx-auto">
        {/* Page Title */}
        <div className="mb-20">
          <h2 className="bank-gothic text-xs tracking-[0.5em] text-neutral-500 mb-4 uppercase">EXPANDING HORIZONS</h2>
          <h3 className="bank-gothic text-4xl md:text-5xl">
            OTHER <span className="accent-text">VENTURES</span>
          </h3>
        </div>

        {/* Intro Description */}
        <div className="max-w-3xl mb-16 text-neutral-400 font-light text-sm md:text-base leading-relaxed">
          Beyond our core architecture and design services, we have diversified into complementary business ventures that extend our expertise and commitment to excellence across multiple sectors.
        </div>

        {/* Ventures Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {ventures.map((venture, index) => (
            <div key={index} className="venture-card group border border-white/5 hover:border-[#c49b66]/30 transition-all duration-500 p-8 flex flex-col">
              {/* Logo Container */}
              <div className="flex items-center justify-center mb-6 h-48 p-6 bg-white/5 group-hover:bg-white/10 transition-all duration-300">
                <img 
                  src={venture.logo} 
                  alt={venture.name}
                  className="max-w-full max-h-full object-contain transition-all duration-500"
                />
              </div>
              
              {/* Venture Name */}
              <h4 className="bank-gothic text-base md:text-lg mb-4 text-white group-hover:text-[#c49b66] transition-colors">
                {venture.name}
              </h4>
              
              {/* Description */}
              <p className="text-xs text-neutral-500 mb-6 font-light leading-relaxed">
                {venture.description}
              </p>
              
              {/* Contact Info */}
              <div className="mt-auto space-y-4">
                {/* Address */}
                <div className="flex items-start space-x-3">
                  <svg className="w-4 h-4 text-[#c49b66] mt-1 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <p className="text-xs text-neutral-400 font-light leading-relaxed">
                    {venture.address}
                  </p>
                </div>
                
                {/* Email */}
                <div className="flex items-center space-x-3">
                  <svg className="w-4 h-4 text-[#c49b66] flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                  <a 
                    href={`mailto:${venture.email}`}
                    className="text-xs text-neutral-400 hover:text-[#c49b66] transition-colors font-light"
                  >
                    {venture.email}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default OtherVenturesPageNew;
